import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { Project } from '@modules/projects/shared/models/project.model';
import { NavigateService } from '@shared/services/navigate.service';
import { ProjectAPIService } from '@modules/projects/shared/services/project-api.service';
import { SnackBarService } from '@core/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'project-name-cell',
  templateUrl: './project-name-cell.component.html',
  styleUrls: ['./project-name-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule, AngularSvgIconModule, SharedModule]
})
export class ProjectNameCellComponent implements ListCustomCell {
  favouritedID: number;

  @ViewChild('template') template;

  constructor(
    private changes: ChangeDetectorRef,
    public n: NavigateService,
    private service: ProjectAPIService,
    private s: SnackBarService,
    private t: TranslateService
  ) {}

  setFavourite(row) {
    row.isFavourite = !row.isFavourite;
    this.changes.detectChanges();
    if (row.isFavourite) {
      this.service.setFavourite(row.id).subscribe({
        error: () => this.onErrorSetFavourite(row)
      });
    } else {
      this.service.removeFavourite(row.id).subscribe({
        error: () => this.onErrorSetFavourite(row)
      });
    }
  }

  onErrorSetFavourite(row) {
    row.isFavourite = !row.isFavourite;
    this.s.error(this.t.instant('ProjectsList.errorSetFavourite'));
    this.changes.detectChanges();
  }

  checkPermissionToPreview(row: Project) {
    return true;
  }
}
